import { Box } from 'theme-ui';
import { useEffect, cloneElement } from 'react';
import { useInView } from 'react-intersection-observer';

import store, { useSetRecoilState } from '@store';

const defaultOptions = {
  rootMargin: '0px 0px 0px 0px',
  threshold: 1,
  trackVisibility: true,
  delay: 200,
};

export const withInView = (SectionComp, options) => {
  return function (sectionProps) {
    const { ref, inView, entry } = useInView(options || defaultOptions);
    const { id } = sectionProps?.cms || {};
    const updateSectionInView = useSetRecoilState(store.sections(id));

    useEffect(() => {
      updateSectionInView({
        id,
        inView,
        entry,
        selector: `section[data-comp-id="${id}"]`,
      });
    }, [inView, id]);

    return (
      <Box
        data-comp="section-inview"
        ref={ref}
        sx={{
          width: '100%',
          height: '100%',
        }}
      >
        {cloneElement(<SectionComp />, { ...sectionProps, inView, entry })}
      </Box>
    );
  };
};
